export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20fashion%20still%20life%20with%20neatly%20folded%20beige%20sweater%20white%20sneakers%20leather%20bag%20and%20scattered%20accessories%20on%20creamy%20linen%20surface%2C%20golden%20sunset%20light%20streaming%20through%20sheer%20curtains%2C%20editorial%20lifestyle%20photography%2C%20warm%20inviting%20mood%2C%20natural%20organic%20arrangement&width=1800&height=1000&seq=cta-full-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet complete collection showcase with premium fashion items"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6 py-20">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 uppercase tracking-wider leading-tight max-w-3xl">
          Explore the Latest
          <br />
          Sugargoo Spreadsheet
        </h2>

        <p className="mt-5 text-sm md:text-lg text-background-50/80 font-light max-w-xl leading-relaxed">
          Access the most comprehensive, updated Sugargoo spreadsheet with verified finds, trusted seller links,
          and detailed category breakdowns. Start discovering today.
        </p>

        {/* CTA Button */}
        <div className="mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-foreground-900 text-background-50 px-8 py-4 rounded-full text-sm md:text-base font-semibold whitespace-nowrap hover:bg-foreground-800 transition-all cursor-pointer group"
          >
            <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
            </span>
            <span>Buy It Now</span>
            <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}